import React from "react";
import about1 from '../assets/images/contract.jpg'
import about2 from '../assets/images/document.jpg'
import about3 from '../assets/images/lock.jpg'

export default function Features({classlist}){
    const featuresData = [
        {
            image: about1,
            title: "Chat With Your Documents 💬",
            desc: "Say goodbye to endless document searching! Whether it's legal contracts, financial reports, or technical docs, just ask questions naturally and get instant, accurate answers. Your documents finally speak your language."
        },
        {
            image: about2,
            title: "Database Whisperer 🎯",
            desc: "Turn complex database queries into casual conversations. Need sales insights? Just ask 'How's our Q4 performance?' or 'Show me top customers from last month.' It's like having a data analyst at your fingertips!"
        },
        {
            image: about3,
            title: "Fort Knox for Your Data 🛡️",
            desc: "We're obsessed with privacy (in a good way!). Your sensitive data stays on your premises, protected by military-grade security. Local processing, open-source LLMs - we make AI trustworthy again."
        },
    ]
    return(
        <>
            <div className={classlist}>
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Where AI Meets <br/> <span className="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">Common Sense Security</span></h3>

                    <p className="text-slate-400 max-w-xl mx-auto">Tired of choosing between powerful AI and data privacy? With Privix.AI, you don't have to. Get cutting-edge AI capabilities while keeping your sensitive data locked down tight. It's that simple.</p>
                </div>

                <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
                    {featuresData.map((item,index) => {
                        return(
                        <div className="relative overflow-hidden bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-800 hover:shadow-lg dark:hover:shadow-gray-700 transition-all duration-300 group" key={index}>
                            <div className="p-6 pb-0 relative overflow-hidden after:content-[''] after:absolute after:inset-0 after:mx-auto after:w-72 after:h-72 after:bg-gradient-to-tl after:to-amber-400 after:from-fuchsia-600 after:blur-[80px] after:rounded-full">
                                <img src={item.image} className="relative rounded-t-md shadow-md dark:shadow-slate-700 z-1 w-full h-auto transform group-hover:scale-105 transition-transform duration-300" alt=""/>
                            </div>

                            <div className="p-6">
                                <h5 className="text-lg font-semibold mb-3 bg-gradient-to-br from-amber-400 to-fuchsia-600 bg-clip-text text-transparent">{item.title}</h5>
                                <p className="text-slate-400 leading-relaxed">{item.desc}</p>
                            </div>
                        </div>
                        )
                    })}
                </div>

                <div className="text-center mt-8">
                    <p className="text-slate-400 text-sm italic">Already trusted by forward-thinking companies worldwide</p>
                </div>
            </div>
        </>
    )
}